import React, { useRef } from "react";
import CloseIcon from "../icons/CloseIcon";
import useHandleOutside from "@/hooks/useHandleOutside";
// import useOnClickOutside from "@/hooks/useOnClickOutside";

const TamaraModal = ({ show, setShow, locale, amount, fromPDP }) => {
  const ref = useRef();
  useHandleOutside(ref, () => (!fromPDP ? setShow(false) : null));
  return (
    show && (
      <div
        ref={ref}
        className="w-[90vw] md:w-8/12 overflow-hidden h-[80vh] shadow-lg md:h-[614px] rounded-xl fixed top-1/2 left-1/2 -translate-x-1/2 z-[9999] -translate-y-1/2 bg-white"
      >
        <CloseIcon
          onClick={() => setShow(false)}
          className="absolute start-4 top-4"
        />
        <iframe
          width="100%"
          height="100%"
          src={`https://cdn.tamara.co/widget/tamara-introduction.html?lang=${locale}&price=${amount}&currency=SAR&countryCode=SA&colorType=default&showBorder=true&paymentType=installment&numberOfInstallments=4&disableInstallment=false&disablePaylater=true&widgetType=product-widget`}
        ></iframe>
      </div>
    )
  );
};

export default TamaraModal;
